import { useCallback } from 'react';

import { styled, Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

import useLocalStorage from '../../../../hooks/useLocalStorage';
import { useUserAgent } from '../../../../hooks/useUserAgent';

const StyledChip = styled(Chip)`
    z-index: 2;
    border-radius: 4px;
    position: absolute;
    top: 20px;
    left: calc(50% + 12px);
    transform: translate(-50%, 0);
    background-color: #edecfd;
`;

const MoveCanvasHelpChip = () => {
    const { t } = useTranslation('whiteboard');
    const [showHelp, setShowHelp] = useLocalStorage('showHelp', true);

    const handleHideMoveHelpChip = useCallback(() => {
        setShowHelp(false);
    }, [setShowHelp]);

    const { isMobile, isAndroid, isIPad } = useUserAgent(navigator.userAgent);
    const isTouch = isMobile || isAndroid || isIPad;
    const moveHelpChipKey = isTouch ? 'move-help-touch' : 'move-help';

    if (showHelp) {
        return <StyledChip size="small" label={t(moveHelpChipKey)} onDelete={handleHideMoveHelpChip} />;
    }

    return <></>;
};

export default MoveCanvasHelpChip;
